import { createBlueprint as e } from "@made-people/blueprint";
const l = e({
  slots: {
    base: "grid grid-cols-12 gap-6",
    heading: "",
    activeProductsWrapper: "flex flex-col gap-4 w-full",
    contentWrapper: "flex flex-col gap-6",
    listsWrapper: "flex gap-2 flex-col w-full",
    buttonsWrapper: "flex flex-col gap-3",
    bottomSection: "gap-3 flex flex-col mt-4"
  },
  variants: {
    layout: {
      // Mobile-first stack column layout (default)
      column: {
        base: "grid grid-cols-12 gap-6",
        contentWrapper: "col-span-12 order-1 flex flex-col gap-6",
        listsWrapper: "col-span-12 order-2 flex gap-2 flex-col w-full",
        buttonsWrapper: "hidden",
        // Hide desktop buttons in column layout
        bottomSection: "col-span-12 gap-3 flex flex-col mt-4",
        // Show mobile buttons
        activeProductsWrapper: "flex flex-col gap-4 w-full"
        // Always show active products
      },
      // Desktop side-by-side layout
      horizontal: {
        base: "grid grid-cols-12 gap-6",
        contentWrapper: "col-span-12 md:col-span-4 order-1 flex flex-col gap-6 md:pr-6",
        listsWrapper: "col-span-12 md:col-span-8 order-2 flex gap-2 flex-col w-full",
        buttonsWrapper: "hidden md:flex md:flex-col md:gap-3",
        // Show on desktop only
        bottomSection: "col-span-12 gap-3 flex flex-col md:hidden mt-4",
        // Hide on desktop
        activeProductsWrapper: "hidden md:flex md:flex-col md:gap-4 md:w-full"
        // Desktop only
      }
    }
  }
}), r = e({
  slots: {
    wrapper: "p-3 rounded-lg bg-white",
    image: "max-w-[90px] aspect-[2/3]",
    contentWrapper: "flex flex-row gap-4",
    content: "flex flex-col gap-2",
    name: "text-body-lg font-medium",
    description: "",
    price: "text-body-sm font-medium",
    sizeSelectorWrapper: "flex flex-col gap-3",
    sizeSelectorHeading: "text-label-md font-medium",
    sizeSelector: "w-full py-1 px-1 gap-2 text-label-sm",
    size: "col-span-1 text-label-sm",
    priceBeforeDiscount: "text-label-sm line-through",
    priceWrapper: "flex justify-between items-center gap-1",
    productFit: ""
  },
  variants: {}
}), a = e({
  slots: {
    base: "flex flex-col gap-3 py-4",
    trigger: "flex lg:hidden",
    addToCartWrapper: "px-4"
  },
  variants: {}
}), p = e({
  slots: {
    wrapper: "absolute -left-3 top-0 h-full hidden items-center justify-between z-10 md:flex",
    button: "p-3 bg-[#E4E4E7] rounded-full z-10 [&>svg]:h-3 [&>svg]:w-3"
  },
  variants: {}
}), o = e({
  slots: {
    imageWrapper: "aspect-square p-4 bg-white rounded-lg w-full h-full",
    image: "object-cover",
    name: "text-label-md font-medium text-center",
    priceWrapper: "flex justify-between items-center gap-1",
    price: "text-label-md font-medium text-center",
    priceBeforeDiscount: "text-label-sm line-through"
  },
  variants: {}
});
export {
  r as mixAndMatchActiveProductCardBlueprint,
  l as mixAndMatchBlueprint,
  o as mixAndMatchCardBlueprint,
  a as mixAndMatchDrawerBlueprint,
  p as mixAndMatchNavigationBlueprint
};
//# sourceMappingURL=index-blueprint.es.js.map
